import { render, staticRenderFns } from "./finance_view.vue?vue&type=template&id=363b43d3&scoped=true"
import script from "./finance_view.vue?vue&type=script&lang=js"
export * from "./finance_view.vue?vue&type=script&lang=js"
import style0 from "./finance_view.vue?vue&type=style&index=0&id=363b43d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b43d3",
  null
  
)

export default component.exports